import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
// import Paper from '@material-ui/core/Paper';
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import {
  removeSaveProgress,
  setSaveProgress,
} from "../../../Actions/SaveProgressAction";
import { instance } from "../../../Actions/AxiosInstance";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import createstore from "../../../store";
import { convertDateForBackend } from "../../../Utils";

const recipientConst = [{ displayvalue: -99, displayname: "Self" }];

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
});

class SendReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reportForList: [
        { displayvalue: 1, displayname: "Specific Employees" },
        { displayvalue: 2, displayname: "Group of employees" },
      ],
      empList: [...recipientConst],
      empIdList: [-99],
      AllDepartment: [],
      selectedOptions: [],
      locationList: [],
      self: null,
      other: false,
      recipient: recipientConst,
      selectAllEmp: true,
      selectEmp: [],
      // selectEmp: [...recipientConst],
      accountid: null,
      subscriptionid: null,
      reportfor: {
        reportfor: [
          {
            genaratefortypeid: 1,
            genarateforids: null,
            locationids: null,
          },
        ],
      },
      errorEmp: false,
      errorreciepents: false,
      selectBU: "",
      selectDept: "",
      selectLocation: "",
      selectFor: { displayname: "Specific Employees", displayvalue: 1 },
    };
  }

  componentDidMount() {
    this.getEmployeeDetails();
    if (
      this.props.selectSubReport.value == 603 ||
      this.props.selectSubReport.value == 501
    ) {
      this.setState({
        selectFor: "",
      });
    }
    const selectEmp = !this.state.selectAllEmp ? this.state.empList : [];
    this.setState({ selectEmp });
  }

  componentWillMount() {
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    this.setState({ subscriptionid, accountid }, () => {
      this.OnDepartmentChange();
      this.OnBusinessUnitChange();
      // this.getTeam()
      this.getLocation();
    });

    if (this.props.updateId != null) {
      const reportfor = { reportfor: this.props.updateData.ReportFor };
      this.setState({ reportfor });
    }
    // if (this.props.updateId != null) {
    //     if (this.props.updateData.ReportFor[0].genaratefortypeid == 1) {
    //         this.setState({
    //             selectFor: { "displayvalue": 1, "displayname": "Employees", selectAllEmp: true },
    //         })
    //     }
    //     else if (this.props.updateData.ReportFor[0].genaratefortypeid == 0) {
    //         let ids = this.props.updateData.ReportFor[0].genarateforids.split(',')
    //         this.setState({
    //             selectFor: { "displayvalue": 1, "displayname": "Employees", selectAllEmp: false },
    //         }, () => {
    //             for (let id of ids) {
    //                 let selectEmp = this.state.empList.find(x => x.id == this.state.empList.displayvalue)
    //                 this.setState({ selectEmp })
    //             }
    //         })
    //     }
    // }
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops.saveReportFlag) {
      this.saveReport();
      this.props._setState("saveReportFlag", false);
    }
    if (
      JSON.stringify(nextprops.selectedStage) !=
        JSON.stringify(this.props.selectedStage) &&
      JSON.stringify(nextprops.selectedemployeementtype) !=
        JSON.stringify(this.props.selectedemployeementtype)
    ) {
      this.getEmployeeDetails(
        nextprops.selectedStage,
        nextprops.selectedemployeementtype,
      );
    }
  }

  reportFor(val) {
    this.setState({
      selectFor: val,
      selectEmp: "",
      selectGrp: "",
      self: true,
      selectBU: "",
      selectDept: "",
      selectLocation: "",
    });
    if (val.displayvalue == 1) {
      const reportfor = {
        reportfor: [
          {
            genaratefortypeid: 1,
            genarateforids: null,
            locationids: null,
          },
        ],
      };
      this.setState({
        reportfor,
        selectEmp: this.state.empList,
        selectAllEmp: true,
      });
    } else if (val.displayvalue == 2) {
      let reportfor = {};
      reportfor = {
        reportfor: [],
      };
      this.setState({ reportfor }, () => {});
    }
  }

  // empOnChange(val) {
  //   if (val < 1) {
  //     // this.state.errorEmp = true;
  //     let genarateforids = [];
  //     for (const emp of val) {
  //       genarateforids.push(emp.displayvalue);
  //     }
  //     genarateforids = genarateforids.join();
  //     if (genarateforids == "") {
  //       genarateforids = null;
  //     }
  //     const reportfor = { reportfor: [] };

  //     // let index = reportfor.reportfor.f"reportfor": indIndex(x => x.genaratefortypeid == 0)
  //     reportfor.reportfor = [
  //       {
  //         genaratefortypeid: 0,
  //         genarateforids,
  //         locationids: null,
  //       },
  //     ];
  //     this.setState({ reportfor, selectEmp: val });
  //   } else {
  //     // this.state.errorEmp = false;

  //     let genarateforids = [];
  //     for (const emp of val) {
  //       genarateforids.push(emp.displayvalue);
  //     }
  //     genarateforids = genarateforids.join();
  //     if (genarateforids == "") {
  //       genarateforids = null;
  //     }
  //     const reportfor = { reportfor: [] };

  //     // let index = reportfor.reportfor.f"reportfor": indIndex(x => x.genaratefortypeid == 0)
  //     reportfor.reportfor = [
  //       {
  //         genaratefortypeid: 0,
  //         genarateforids,
  //         locationids: null,
  //       },
  //     ];
  //     this.setState({ reportfor, selectEmp: val });
  //   }
  // }

  empOnChange(val) {
    let genarateforids = [];
    for (const emp of val) {
      genarateforids.push(emp.displayvalue);
    }
    genarateforids = genarateforids.join();
    if (genarateforids == "") {
      genarateforids = null;
    }
    const reportfor = { reportfor: [] };

    reportfor.reportfor = [
      {
        genaratefortypeid: 0,
        genarateforids,
        locationids: null,
      },
    ];
    this.setState({ reportfor, selectEmp: val });
  }

  recipientsOnChange(val) {
    if (val.length === 0) {
      this.setState({ errorreciepents: true });
      const empIdList = [];
      for (const empId of val) {
        empIdList.push(empId.displayvalue);
      }
      this.setState({ recipient: val, empIdList });
    } else {
      this.setState({ errorreciepents: false });
      const empIdList = [];
      for (const empId of val) {
        empIdList.push(empId.displayvalue);
      }
      this.setState({ recipient: val, empIdList });
    }
  }

  getEmployeeDetails = (selectedStage, selectedemployeementtype) => {
    const data = {
      accountid: this.state.accountid,
      statusid: null,
      subscriptionid: this.state.subscriptionid,
      featurekey: "reportRobo",
    };
    if (this.props.selectedStage) {
      data.stageids = selectedStage
        ? selectedStage.map((x) => x.displayvalue).join(",")
        : this.props.selectedStage
        ? this.props.selectedStage.map((x) => x.displayvalue).join(",")
        : null;
    }
    if (this.props.selectedemployeementtype) {
      data.employmenttypeids = selectedemployeementtype
        ? selectedemployeementtype.map((x) => x.displayvalue).join(",")
        : this.props.selectedemployeementtype
        ? this.props.selectedemployeementtype
            .map((x) => x.displayvalue)
            .join(",")
        : null;
    }
    const URL = `subscription/getemployeelist`;
    // let URL = `subscription/getemployeelist/${this.state.accountid}/${this.state.subscriptionid}/1`
    instance.post(URL, data).then(
      (response) => {
        if (response.data.result) {
          this.setState(
            {
              empList: [...recipientConst, ...response.data.result],
              stageids: data.stageids || null,
              employmenttypeids: data.employmenttypeids || null,
              selectEmp: [...recipientConst, ...response.data.result],
            },
            () => {
              if (this.props.updateId != null) {
                if (
                  this.props.updateData.ReportData[0].requestedemployeeid ==
                  null
                ) {
                  this.setState({ self: false });
                } else if (
                  this.props.updateData.ReportData[0].requestedemployeeid !=
                  null
                ) {
                  this.setState({ self: true });
                }
                // if(this.props.updateData.ReportData[0].additionalrecipientempids == null){
                //   this.setState({ selectAllEmp: true })
                // }
                if (
                  this.props.updateData.ReportData[0]
                    .additionalrecipientempids != null
                ) {
                  // next code dest
                  // this.setState({ other: true }, () => {

                  const recipient = [];
                  let empIdList = [];
                  empIdList =
                    this.props.updateData.ReportData[0].additionalrecipientempids.split(
                      ",",
                    );
                  if (this.props.updateData.ReportData[0].requestedemployeeid) {
                    empIdList = [...this.state.empIdList, ...empIdList];
                    // recipient = recipientConst
                  }

                  for (const ids of empIdList) {
                    const id = Number(ids);
                    const selectEmp = this.state.empList.find(
                      (x) => x.displayvalue == id,
                    );
                    recipient.push(selectEmp);
                  }
                  this.setState({ empIdList, recipient, other: true });
                  // });
                }
                const reportFor = {
                  reportfor: this.props.updateData.ReportFor,
                };
                if (this.props.updateData.ReportFor.length > 0) {
                  if (
                    this.props.updateData.ReportFor[0].genaratefortypeid == 1
                  ) {
                    this.setState({
                      reportFor,
                      selectFor: { displayvalue: 1, displayname: "Employees" },
                    });
                  } else if (
                    this.props.updateData.ReportFor[0].genaratefortypeid == 0
                  ) {
                    const ids =
                      this.props.updateData.ReportFor[0].genarateforids.split(
                        ",",
                      );
                    this.setState(
                      {
                        selectFor: {
                          displayvalue: 1,
                          displayname: "Employees",
                          reportFor,
                        },
                      },
                      () => {
                        const selectEmp = [];
                        for (const id of ids) {
                          const sel = this.state.empList.find(
                            (x) => x.displayvalue == id,
                          );
                          selectEmp.push(sel);
                        }
                        this.setState({
                          selectEmp,
                          selectAllEmp: !this.state.selectAllEmp,
                        });
                      },
                    );
                  }
                }
              }
            },
          );
        } else {
          this.props.enqueueSnackbar("Please Add more employee", {
            variant: "error",
          });
        }
      },
      (error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      },
    );
  };
  // getDeptTeam() {
  //     instance.get(`reportrobo/departamentlist`).then(result => {
  //         let AllDepartment = result.data.result || []
  //         this.setState({ AllDepartment }, () => {

  //         })
  //     }).catch(error => {
  //         this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: 'error' })
  //     })
  // }
  OnBusinessUnitChange() {
    const data = {
      featurekey: "reportRobo",
    };
    instance
      .post(`subscription/allbusinessunit`, data)
      .then((result) => {
        // if (result.data.result.length > 0) {
        //     for (let dat of result.data.result) {
        //         if (dat.options) {
        //             dat.options = JSON.parse(dat.options)
        //         } else {
        //             dat.options = []
        //         }
        //     }
        //     AllBU = result.data.result
        // }
        // else {
        //     AllBU = []
        // }
        this.setState({ AllBU: result.data.result }, () => {
          if (
            this.props.updateId != null &&
            this.props.updateData.ReportFor.length > 0
          ) {
            for (const rpt of this.props.updateData.ReportFor) {
              if (rpt.genaratefortypeid == 2) {
                const selectBU = [];
                const ids = rpt.genarateforids.split(",");
                for (const id of ids) {
                  const select = this.state.AllBU.find(
                    (x) => x.displayvalue == id,
                  );
                  selectBU.push(select);
                }
                this.setState({
                  selectBU,
                  selectFor: { displayvalue: 2, displayname: "Group" },
                });
              }
            }
          }
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  OnDepartmentChange() {
    const data = {
      featurekey: "reportRobo",
      businessunitid: null,
    };
    instance
      .post(`subscription/departmentbybuidwithglobal`, data)
      .then((result) => {
        let AllDepartment = [];
        if (result.data.result.length > 0) {
          for (const dat of result.data.result) {
            if (dat.options) {
              dat.options = JSON.parse(dat.options);
            } else {
              dat.options = [];
            }
          }
          AllDepartment = result.data.result;
        } else {
          AllDepartment = [];
        }
        this.setState({ AllDepartment }, () => {
          if (
            this.props.updateId != null &&
            this.props.updateData.ReportFor.length > 0
          ) {
            for (const rpt of this.props.updateData.ReportFor) {
              if (rpt.genaratefortypeid == 3) {
                const alldeprtamentoption = [];
                this.state.AllDepartment.forEach((option) => {
                  alldeprtamentoption.push(...option.options);
                });
                const selectDept = [];
                const ids = rpt.genarateforids.split(",");
                for (const id of ids) {
                  const select = alldeprtamentoption.find((x) => x.value == id);
                  selectDept.push(select);
                }
                this.setState({
                  selectDept,
                  selectFor: { displayvalue: 2, displayname: "Group" },
                });
              }
            }
          }
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }
  // getTeam() {
  //     instance.get(`subscription/allteam`).then(result => {

  //         this.setState({ AllTeam: result.data.result })
  //     }).catch(error => {
  //         this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: 'error' })
  //     })
  // }
  getLocation() {
    const data = {
      featurekey: "reportRobo",
      subscriptionid: this.state.subscriptionid,
    };
    instance
      .post(`subscription/allcompanylocation`, data)
      .then((result) => {
        // let AllDepartment =
        this.setState({ locationList: result.data.result || [] }, () => {
          if (
            this.props.updateId != null &&
            this.props.updateData.ReportFor.length > 0 &&
            this.props.updateData.ReportFor[0].locationids != null
          ) {
            const selectLocation = [];
            const ids =
              this.props.updateData.ReportFor[0].locationids.split(",");
            for (const id of ids) {
              const select = this.state.locationList.find(
                (x) => x.displayvalue == id,
              );
              selectLocation.push(select);
            }
            // let selectLocation = this.state.locationList.find(x => x.displayvalue == this.props.updateData.ReportFor[0].locationids)
            this.setState({ selectLocation });
          }
          if (
            this.props.updateId != null &&
            this.props.updateData.ReportFor.length > 0
          ) {
            for (const rpt of this.props.updateData.ReportFor) {
              if (rpt.genaratefortypeid == 6) {
                this.setState({
                  selectFor: { displayvalue: 2, displayname: "Group" },
                });
              }
            }
          }
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  grpOnChange(val) {
    this.setState({ selectGrp: val });
  }

  locationOnChange(val) {
    let locationids = [];
    for (const emp of val || []) {
      locationids.push(emp.displayvalue);
    }
    locationids = locationids.join();

    if (this.state.reportfor.reportfor.length > 0) {
      const { reportfor } = this.state;
      const indexBu = reportfor.reportfor.findIndex(
        (x) => x.genaratefortypeid == 2,
      );
      const indexDept = reportfor.reportfor.findIndex(
        (x) => x.genaratefortypeid == 3,
      );
      // let indexLoc = reportfor.reportfor.findIndex(x => x.genaratefortypeid == 6)
      if (indexBu != -1) {
        Object.assign(reportfor.reportfor[indexBu], { locationids });
      }
      if (indexDept != -1) {
        Object.assign(reportfor.reportfor[indexDept], { locationids });
      }
      this.setState({ reportfor, selectLocation: val });
    } else {
      const reportfor2 = {
        reportfor: [
          {
            genaratefortypeid: 6,
            genarateforids: null,
            locationids,
          },
        ],
      };
      // this.setState({ reportfor })
      this.setState({ reportfor: reportfor2, selectLocation: val });
    }
  }

  selfOnChange() {
    this.setState({ self: !this.state.self });
  }

  selectAllEmpOnChange() {
    let reportfor = {
      reportfor: [
        {
          genaratefortypeid: 1,
          genarateforids: null,
          locationids: null,
        },
      ],
    };

    const selectEmp = !this.state.selectAllEmp ? this.state.empList : [];
    this.setState(
      { selectAllEmp: !this.state.selectAllEmp, selectEmp, reportfor },
      () => {
        if (this.state.selectAllEmp == false) {
          reportfor = {
            reportfor: [
              {
                genaratefortypeid: 0,
                genarateforids: null,
                locationids: null,
              },
            ],
          };
          this.setState({ reportfor });
        }
      },
    );
    /*
                this.setState({ selectAllEmp: !this.state.selectAllEmp }, () => {
                    if (this.state.selectAllEmp == true) {
                        this.setState({
                            selectEmp: this.state.empList
                        })
                    }
                    else {
                        this.setState({
                            selectEmp: []
                        })
                    }
                })

        */
  }

  daysInThisMonth(date) {
    const now = new Date(date);
    return new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  }

  saveReport() {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    const masterprofileid =
      this.props.AuthenticationAction.login.masterprofileid;
    if (!issaveinprogress) {
      if (this.state.empList && this.state.empList.length <= 0) {
        this.props.enqueueSnackbar("Please Add More Employees", {
          variant: "error",
        });
        this.setState({ errorEmp: true });
        return null;
      }
      if (!this.state.empList) {
        this.props.enqueueSnackbar("Please Add More Employees", {
          variant: "error",
        });
        this.setState({ errorEmp: true });
        return null;
      }
      if (this.state.errorreciepents == true) {
        this.props.enqueueSnackbar(
          "Please select atleast one recipient to send report",
          { variant: "error" },
        );
        this.setState({ errorreciepents: true });
        return null;
      }
      if (this.state.recipient.length <= 0 && this.state.other == true) {
        this.props.enqueueSnackbar(
          "Please select atleast one recipient to send report",
          { variant: "error" },
        );
        this.setState({ errorreciepents: true });
        return null;
      }
      if (
        !this.state.selectFor &&
        ![501, 603].some((rpID) => rpID == this.props.selectSubReport.value)
      ) {
        this.props.enqueueSnackbar("Please select data to be included", {
          variant: "error",
        });
        return null;
      }

      this.setState({ errorEmp: false, errorreciepents: false }, () => {
        // if (this.state.selectAllEmp || (!this.state.selectAllEmp && this.state.selectEmp.length > 0)) {
        if (this.props.generationtypeid == 1) {
          // data code here
          const { fromDate } = this.props;
          const { toDate } = this.props;
          if (this.props.sendDate) {
            if (!this.props.fromDate || !this.props.toDate) {
              this.props.enqueueSnackbar("Please select date", {
                variant: "error",
              });
              return;
            }
          } else {
            this.props.enqueueSnackbar("Please select date range type", {
              variant: "error",
            });
            return;
          }
          // eslint-disable-next-line no-extend-native
          Array.prototype.unique = function () {
            return this.filter(
              (value, index, self) => self.indexOf(value) === index,
            );
          };

          const data = {
            generationtypeid: this.props.generationtypeid,
            reportcatagoryid: this.props.reportcatagoryid,
            reporttypeid: this.props.reporttypeid,
            reportfor: {
              reportforlog: this.state.reportfor.reportfor.map((y) => ({
                ...y,
                genarateforids:
                  typeof y.genarateforids == "string"
                    ? y.genarateforids.replace("-99", "")
                    : masterprofileid == 8
                    ? this.state.empList
                        .map((x) => x.displayvalue)
                        .splice(1)
                        .join(",")
                    : null,
                stageids: this.props.selectedStage
                  .map((x) => x.displayvalue)
                  .join(","),
                reviewformids:
                  this.props.selectedreviewform &&
                  this.props.selectedreviewform.displayvalue,
                employmenttypeids: this.props.selectedemployeementtype
                  .map((x) => x.displayvalue)
                  .join(","),
              })),
            },
            requestedemployeeid:
              get(this.state, "empIdList", []).findIndex((x) => x == "-99") !=
              -1,
            fromdate: convertDateForBackend(fromDate),
            todate: convertDateForBackend(toDate),
            additionalrecipientempids: get(this.state, "empIdList", [])
              .filter((x) => x != -99)
              .unique(),
          };

          if (this.props.reporttypeid == 603) {
            data.reportfor.reportforlog = [
              {
                genaratefortypeid: "1",
                genarateforids: null,
                stageids: null,
                reviewformids:
                  this.props.selectedreviewform &&
                  this.props.selectedreviewform.displayvalue,
                employmenttypeids: null,
              },
            ];
          }
          // return;
          if (
            get(this.state, "selectFor.displayvalue", "") ||
            [501, 603].some((rpID) => rpID == this.props.selectSubReport.value)
          ) {
            if (
              this.state.selectFor &&
              this.state.selectFor.displayvalue == 1 &&
              this.state.selectEmp.length < 1
            ) {
              this.props.enqueueSnackbar("Please Select Employees", {
                variant: "error",
              });
            } else if (
              this.state.selectFor &&
              this.state.selectFor.displayvalue == 2 &&
              this.state.reportfor.reportfor &&
              this.state.reportfor.reportfor.length < 1
            ) {
              this.props.enqueueSnackbar("Please select at least one group", {
                variant: "error",
              });
            } else if (
              [501, 603].some(
                (rpId) => rpId == this.props.selectSubReport.value,
              ) ||
              this.state.reportfor.reportfor[0].genaratefortypeid == 2 ||
              this.state.reportfor.reportfor[0].genaratefortypeid == 3 ||
              this.state.reportfor.reportfor[0].genaratefortypeid == 1 ||
              (this.state.reportfor.reportfor[0].genaratefortypeid == 0 &&
                this.state.reportfor.reportfor[0].genarateforids != null) ||
              this.state.reportfor.reportfor[0].genaratefortypeid == 6 ||
              this.state.other == false ||
              (this.state.other == true && this.state.recipient.length > 0)
            ) {
              this.props.setSaveProgress(true);
              instance
                .post("/reportrobo/reportrobolog", data)
                .then(() => {
                  this.props.enqueueSnackbar(
                    "Saved . The Report will be mailed to you in 5 minutes",
                    {
                      variant: "success",
                    },
                  );
                  this.props.clearReportType();
                  this.props.removeSaveProgress();
                })
                .catch((error) => {
                  this.props.removeSaveProgress();
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                });
            } else {
              if (
                this.state.reportfor.reportfor[0].genaratefortypeid == 0 &&
                this.state.reportfor.reportfor[0].genarateforids == null
              ) {
                this.props.enqueueSnackbar("Please Select Employees", {
                  variant: "error",
                });
                this.setState({ errorEmp: true });
              }
              if (
                this.state.other == true &&
                this.state.recipient.length == 0
              ) {
                this.props.enqueueSnackbar("Please Select Employees", {
                  variant: "error",
                });
                this.setState({ errorreciepents: true });
              }
            }
          }
        }

        if (this.props.generationtypeid == 2) {
          const date = this.props.scheduledtime;
          const scheduledtime = moment(date, "HH:mm").format("HH:mm");
          const data = {
            generationtypeid: this.props.generationtypeid,
            frequencytypeid: this.props.frequencytypeid,
            frequencyvalue: this.props.frequencyvalue
              ? this.props.frequencyvalue
              : 0,
            reportcatagoryid: this.props.reportcatagoryid,
            reporttypeid: this.props.reporttypeid,
            reportfor: {
              reportfor: this.state.reportfor.reportfor.map((y) => ({
                ...y,
                stageids: this.state.stageids,
                employmenttypeids: this.state.employmenttypeids,
              })),
            },
            requestedemployeeid:
              get(this.state, "empIdList", []).findIndex((x) => x == "-99") !=
              -1,
            scheduledtime,
            requeststartdate: null,
            additionalrecipientempids:
              this.state.empIdList.filter((x) => x != -99) || null,
            reportroboid:
              this.props.updateId == null ? null : this.props.updateId,
          };

          // if (this.state.selectFor.displayvalue == 1 && this.state.selectEmp.length < 1) {
          //   this.props.enqueueSnackbar("Please Select Employees", { variant: "error" });
          // } else
          if (
            this.state.selectFor.displayvalue == 2 &&
            this.state.reportfor.reportfor &&
            this.state.reportfor.reportfor.length < 1
          ) {
            this.props.enqueueSnackbar("Please select at least one group", {
              variant: "error",
            });
          } else if (
            (this.state.reportfor.reportfor[0].genaratefortypeid == 2 ||
              this.state.reportfor.reportfor[0].genaratefortypeid == 3 ||
              this.state.reportfor.reportfor[0].genaratefortypeid == 1 ||
              (this.state.reportfor.reportfor[0].genaratefortypeid == 0 &&
                this.state.reportfor.reportfor[0].genarateforids != null) ||
              this.state.reportfor.reportfor[0].genaratefortypeid == 6) &&
            (this.state.other == false ||
              (this.state.other == true && this.state.recipient.length > 0))
          ) {
            this.props.setSaveProgress(true);
            instance
              .post("/reportrobo/reportroboget", data)
              .then(() => {
                this.props.enqueueSnackbar("saved successfully", {
                  variant: "success",
                });
                this.props.clearReportType();
                this.props.removeSaveProgress();
              })
              .catch((error) => {
                this.props.removeSaveProgress();
                const CommonError = error.response
                  ? error.response.data.error.message
                  : error.message;
                this.props.enqueueSnackbar(CommonError, { variant: "error" });
              });
            // }
          } else {
            if (
              this.state.reportfor.reportfor[0].genaratefortypeid == 0 &&
              this.state.reportfor.reportfor[0].genarateforids == null
            ) {
              this.props.enqueueSnackbar("Please Select Employees", {
                variant: "error",
              });
              this.setState({ errorEmp: true });
            }
            if (this.state.other == true && this.state.recipient.length == 0) {
              this.props.enqueueSnackbar("Please Select Employees", {
                variant: "error",
              });
              this.setState({ errorreciepents: true });
            }
          }
        }
      });
    }
  }

  buOnChange(val) {
    // let genarateforids = []
    // for (let emp of val) {
    //     genarateforids.push(emp.displayvalue)
    // }
    // genarateforids = genarateforids.join()
    // let reportfor = this.state.reportfor
    // let index = reportfor.reportfor.findIndex(x => x.genaratefortypeid == 2)

    // let objectData = {
    //     genaratefortypeid: 2,
    //     genarateforids,
    //     locationids: null
    // }
    // if (index >= 0)
    //     reportfor.reportfor[index] = objectData
    // else
    //     reportfor.reportfor.push(objectData)

    // this.setState({ reportfor, selectBU: val })
    if (val && val.length > 0) {
      const { reportfor } = this.state;
      const indexloc = reportfor.reportfor.findIndex(
        (x) => x.genaratefortypeid == 6,
      );
      if (indexloc != -1) {
        reportfor.reportfor.splice(indexloc, 1);
      }
      let genarateforids = [];
      for (const emp of val) {
        genarateforids.push(emp.displayvalue);
      }
      genarateforids = genarateforids.join();
      const index = reportfor.reportfor.findIndex(
        (x) => x.genaratefortypeid == 2,
      );
      let objectData = {};
      if (this.state.selectLocation.length == 0) {
        objectData = {
          genaratefortypeid: 2,
          genarateforids,
          locationids: null,
        };
      } else if (this.state.selectLocation.length > 0) {
        let locationids = [];
        for (const loc of this.state.selectLocation) {
          locationids.push(loc.displayvalue);
        }
        locationids = locationids.join();
        // let locationids = this.state.selectLocation.join()
        objectData = {
          genaratefortypeid: 2,
          genarateforids,
          locationids,
        };
      }
      if (index >= 0) reportfor.reportfor[index] = objectData;
      else reportfor.reportfor.push(objectData);

      this.setState({ reportfor, selectBU: val });
    } else {
      let { reportfor } = this.state;
      const index = reportfor.reportfor.findIndex(
        (x) => x.genaratefortypeid == 2,
      );
      reportfor.reportfor.splice(index, 1);
      this.setState({ reportfor, selectBU: val }, () => {
        if (this.state.reportfor.reportfor.length == 0) {
          if (this.state.reportfor.reportfor.length == 0) {
            if (this.state.selectLocation.length > 0) {
              let locationids = [];
              for (const loc of this.state.selectLocation) {
                locationids.push(loc.displayvalue);
              }
              locationids = locationids.join();
              reportfor = {
                reportfor: [
                  {
                    genaratefortypeid: 6,
                    genarateforids: null,
                    locationids,
                  },
                ],
              };
              this.setState({ reportfor });
            }

            // this.setState({ selectLocation: [] })
          }
        }
      });
    }
  }

  deptOnChange(val) {
    const { selectLocation = [] } = this.state;
    let { reportfor } = this.state;
    if (val && val.length > 0) {
      const indexloc = reportfor.reportfor.findIndex(
        (x) => x.genaratefortypeid == 6,
      );
      if (indexloc != -1) {
        reportfor.reportfor.splice(indexloc, 1);
      }
      let genarateforids = [];
      for (const emp of val) {
        genarateforids.push(emp.value);
      }
      genarateforids = genarateforids.join();
      const index = reportfor.reportfor.findIndex(
        (x) => x.genaratefortypeid == 3,
      );
      let objectData = {};
      if (selectLocation.length == 0) {
        objectData = {
          genaratefortypeid: 3,
          genarateforids,
          locationids: null,
        };
      } else if (selectLocation.length > 0) {
        let locationids = [];
        for (const loc of selectLocation) {
          locationids.push(loc.displayvalue);
        }
        locationids = locationids.join();
        // let locationids = this.state.selectLocation.join()
        objectData = {
          genaratefortypeid: 3,
          genarateforids,
          locationids,
        };
      }
      if (index >= 0) reportfor.reportfor[index] = objectData;
      else reportfor.reportfor.push(objectData);

      this.setState({ reportfor, selectDept: val });
    } else {
      const index = reportfor.reportfor.findIndex(
        (x) => x.genaratefortypeid == 3,
      );
      reportfor.reportfor.splice(index, 1);
      this.setState({ reportfor, selectDept: val }, () => {
        if (this.state.reportfor.reportfor.length == 0) {
          if (selectLocation.length > 0) {
            let locationids = [];
            for (const loc of selectLocation) {
              locationids.push(loc.displayvalue);
            }
            locationids = locationids.join();
            reportfor = {
              reportfor: [
                {
                  genaratefortypeid: 6,
                  genarateforids: null,
                  locationids,
                },
              ],
            };
            this.setState({ reportfor });
          }

          // this.setState({ selectLocation: [] })
        }
      });
    }
  }

  // teamOnChange(val) {
  //     let genarateforids = []
  //     for (let emp of val) {
  //         genarateforids.push(emp.displayvalue)
  //     }
  //     genarateforids = genarateforids.join()
  //     let reportfor = this.state.reportfor
  //     let index = reportfor.reportfor.findIndex(x => x.genaratefortypeid == 4)

  //     let objectData = {
  //         genaratefortypeid: 4,
  //         genarateforids,
  //         locationids: null
  //     }
  //     if (index >= 0)
  //         reportfor.reportfor[index] = objectData
  //     else
  //         reportfor.reportfor.push(objectData)

  //     this.setState({ reportfor, selectTeam: val })
  // }
  render() {
    const language = this.props.Language.reportrobo;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="">
          {![501, 603].some(
            (rpID) => rpID == this.props.selectSubReport.value,
          ) && (
            <div>
              <p className="input-form-label" />
              <div className="inner-wrapper opaque">
                <div className="form-group">
                  <p className="add-label-active">
                    Specific Employees / Group of Employees
                  </p>
                  <Select
                    class="form-control"
                    autofocus
                    placeholder="Select"
                    options={this.state.reportForList}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={this.reportFor.bind(this)}
                    value={this.state.selectFor}
                  />
                  {/* <SelectList
                    data={this.state.reportForList}
                    Selected={this.state.selectFor ? this.state.selectFor.displayvalue : null}
                    onSelected={this.reportFor.bind(this)}
                  /> */}
                </div>
              </div>
            </div>
          )}
          {this.state.selectFor ||
          [501, 603].some(
            (rpID) => rpID == this.props.selectSubReport.value,
          ) ? (
            <div className="inner-wrapper opaque">
              {this.state.selectFor &&
              this.state.selectFor.displayvalue == 1 ? (
                <div className="form-group">
                  <p className="add-label-active">
                    <FormattedMessage
                      defaultMessage="Employees"
                      id="LbEmployees"
                    />
                  </p>
                  <div className="margin-bottom-8">
                    <Select
                      class="form-control"
                      autofocus
                      placeholder="Select Employee"
                      isMulti
                      isDisabled={this.state.selectAllEmp}
                      options={this.state.empList.filter(
                        (x) => x.displayvalue != -99,
                      )}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      onChange={this.empOnChange.bind(this)}
                      value={
                        this.state.selectAllEmp
                          ? [{ displayname: "all", displayvalue: -98 }]
                          : this.state.selectEmp
                      }
                    />
                    {this.state.errorEmp ? (
                      <span className="validation-text">
                        *Please select Employees
                      </span>
                    ) : null}
                  </div>
                  <Checkbox
                    checked={this.state.selectAllEmp}
                    onChange={this.selectAllEmpOnChange.bind(this)}
                    value={this.state.selectAllEmp}
                    color="primary"
                    className="custom-checkbox floatleft"
                  />
                  <FormattedMessage
                    id="LbSelectAllEmployees"
                    defaultMessage="Select All Employees"
                  />
                </div>
              ) : this.state.selectFor &&
                this.state.selectFor.displayvalue == 2 ? (
                <div>
                  <div className="margin-bottom-20">
                    <p className="add-label-active">
                      <FormattedMessage
                        id="LbBusinessUnit"
                        defaultMessage="Business Unit"
                      />
                    </p>
                    <Select
                      class="form-control"
                      autofocus
                      placeholder="Select Business Unit"
                      isMulti
                      options={this.state.AllBU}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      onChange={this.buOnChange.bind(this)}
                      value={this.state.selectBU}
                    />
                  </div>
                  <div className="margin-bottom-20">
                    <p className="add-label-active">
                      <FormattedMessage
                        id="LbDepartment"
                        defaultMessage="Department"
                      />
                    </p>
                    <Select
                      class="form-control"
                      autofocus
                      placeholder="Select Department"
                      isMulti
                      options={this.state.AllDepartment}
                      // getOptionLabel={(option) => option.displayname}
                      // getOptionValue={(option) => option.displayvalue}
                      onChange={this.deptOnChange.bind(this)}
                      value={this.state.selectDept}
                    />
                  </div>
                  <div className="margin-bottom-20">
                    <p className="add-label-active">
                      <FormattedMessage
                        id="LbLocation"
                        defaultMessage="Location"
                      />
                    </p>
                    <Select
                      class="form-control"
                      autofocus
                      placeholder="Select Locations"
                      isMulti
                      options={this.state.locationList}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      onChange={this.locationOnChange.bind(this)}
                      value={this.state.selectLocation}
                    />
                  </div>
                </div>
              ) : null}

              <div className="inner-wrapper opaque">
                <p className="add-label-active">Who receives this report?</p>
                <div className="">
                  <Select
                    class="form-control"
                    autofocus
                    placeholder="Select Employee"
                    isMulti
                    options={this.props.mainempList}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={this.recipientsOnChange.bind(this)}
                    value={this.state.recipient}
                  />
                  {this.state.errorreciepents ? (
                    <span className="validation-text">
                      *Please select Employees
                    </span>
                  ) : null}
                  <br />
                </div>
              </div>
            </div>
          ) : null}
          {false &&
            (this.state.self ||
              (this.state.other && this.state.recipient.length > 0)) && (
              <div className="margin-top-30 margin-bottom-30">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={this.props.SaveInProgressReducer.issaveinprogress}
                  onClick={() => {
                    this.saveReport();
                  }}
                >
                  <FormattedMessage id="BtSave" defaultMessage="Save" />
                </Button>
              </div>
            )}
        </div>
      </IntlProvider>
    );
  }
}

SendReport.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SaveInProgressReducer: state.SaveInProgressReducer,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSaveProgress,
      removeSaveProgress,
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(SendReport)));
